import React, { useState } from 'react';

import { observer } from 'mobx-react-lite';
import { RatingType } from 'stores/rating_store';
import useStores from 'hooks/useStores';

// type RateItemProps = {
//     identity: string;
//     item_owner_identity: string;
//     item_uuid: string;
//     score: number;
// }

type RatingContextType = {

    // Fetch and get one
    rateItem: (item_uuid: string, score: number, identity: string, item_owner_identity: string) => Promise<RatingType>;

    // Fetch and get list by identity
    fetchListByIdentityRating: (identity_uuid: string) => Promise<RatingType[]>;
    getListByIdentityRating: (identity_uuid: string) => RatingType[];

    // Contains all known Rating items
    items: RatingType[];
}

export const RatingContext = React.createContext<RatingContextType>({

    rateItem: () => { throw 'Not Implemented' },
    fetchListByIdentityRating: () => { throw 'Not Implemented' },
    getListByIdentityRating: () => { throw 'Not Implemented' },
    items: [] as RatingType[],
});




export const RatingProvider = observer(({ children }: { children: React.ReactNode }) => {
    const [items, setRating] = useState([] as RatingType[]);
    const { ratingStore } = useStores();

    // const addItems = (newItems: RatingType[] | RatingType) => {
    //     // Autogenerated
    //     newItems = Array.isArray(newItems) ? newItems : [newItems];
    //     setRating([...items, ...newItems]);
    // };

    const rateItem = async (item_uuid: string, score: number, identity: string, item_owner_identity: string) => {
        console.log('rateItem', identity, item_uuid, item_owner_identity, score);
        return ratingStore.rateItem(item_uuid, score, identity, item_owner_identity)
            .then((item) => {
                console.log('item', item);
                setRating(ratingStore.items);
                return item;
            });
    };

    const fetchRating = async (uuid: string) => {
        // Autogenerated
        return ratingStore.fetchRating(uuid);
    };

    const getRating = (uuid: string) => {
        // Autogenerated
        return items.find((item) => item.uuid === uuid) || null;
    };

    const fetchListByIdentityRating = async (identity_uuid: string) => {
        // Autogenerated
        return ratingStore.fetchListByIdentityRating(identity_uuid)
            .then(() => {
                setRating(ratingStore.items);
                return getListByIdentityRating(identity_uuid);
            });
    };

    const getListByIdentityRating = (identity_uuid: string) => {
        // Autogenerated
        return items.slice().filter((item) => item.identity === identity_uuid);
    };

    const data = {
        rateItem,
        fetchRating,
        getRating,
        fetchListByIdentityRating,
        getListByIdentityRating,
        items,
    };

    return (
        <RatingContext.Provider value={data}>{ children }</RatingContext.Provider>
    );

});
